/* ototo-crazyrocket.js — the spin wheel opens AT REST, no intro spin (user, 2026-11-04).

   CrazyRocket plays a 4 s "intro" spin every time the popup opens (`spin(false)`, hard-coded,
   no setting). It animates through `window.crazyrocketFrameAnimation`, which it only creates
   when it is still undefined, so defining it here first (this file loads, deferred, before
   CrazyRocket's own deferred loader) puts every CrazyRocket animation frame through `frame()`.

   The FIRST animation after each opening is the intro: its first frame sets the start time, the
   frame it requests is dropped, and a second call far in the future lands it on its stop position
   in one paint (the slice the pointer rests on, chosen by the reward order in CrazyRocket).
   Every later animation, the real spin included, runs untouched. If CrazyRocket ever renames
   the hook, this file simply stops mattering and the intro spin comes back. */
(function () {
  if (window.crazyrocketFrameAnimation) return;
  var raf = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (cb) { return setTimeout(function () { cb(Date.now()); }, 16); };
  var introDone = false;
  var swallow = false;

  function popupOpen() {
    var o = document.getElementById('crazyrocket-popup-overlay');
    return !!o && getComputedStyle(o).display !== 'none';
  }

  /* Closing re-arms the skip for the next opening. */
  setInterval(function () { if (introDone && !popupOpen()) introDone = false; }, 250);

  window.crazyrocketFrameAnimation = function frame(cb) {
    if (swallow) return 0;
    return raf(function (t) {
      if (!introDone && popupOpen()) {
        introDone = true;
        swallow = true;
        try { cb(t); } finally { swallow = false; }
        cb(t + 1e7);
        return;
      }
      cb(t);
    });
  };
})();
